import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';

import MainForm from './partials/MainForm';
import Error from '../../components/Error';

class App extends React.Component {
    render() {
        return (
            <div className="app-wrapper">
                {this.props.children}
            </div>
        );
    }
}

const routes = (
    <Router history={browserHistory}>
        <Route path="/familyshield" component={App}>
            <IndexRoute component={MainForm} />
            <Route path="/familyshield/error(/:type)" component={Error} />
        </Route>
    </Router>
);

ReactDOM.render(routes, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/familyshield/js/entry.js